import React from "react"
import moment from 'moment';

import { StudioManager } from "../../studio-manager";

export class ComingUp extends React.Component {
  constructor () {
    super();
    this.state = {
      currentlyPlaying: true,
      time : '16:00',
      left: [],
      right: []
    }
  }

  componentDidMount () {
    StudioManager.instance.on('slots-updated', this.update);
  }

  update = () => {
    const now = moment();
    var currentlyPlaying = StudioManager.instance.slotA.start.isBefore(now);
    var time = StudioManager.instance.slotA.start.format('HH:mm');

    var lastForToday = StudioManager.instance.agenda[0].events[StudioManager.instance.agenda[0].events.length - 1];
    var lastHasPassed = lastForToday ? lastForToday.end.isBefore(now) : true;
    
    var index = lastHasPassed ? 1 : 0;
    
    var half = Math.ceil(StudioManager.instance.agenda[index].events.length / 2);
    var left = StudioManager.instance.agenda[index].events.slice(0, half);
    var right = StudioManager.instance.agenda[index].events.slice(half);

    this.setState({ currentlyPlaying, left, right, time });
  }

  get videoSrc () {
    return '/video/' + (window.innerWidth < 800 ? 'mobile.mp4' : 'desktop.mp4' );
  }

  render () {
    return !this.state.currentlyPlaying ? (
      <div className="coming-up__container">
        <video className="coming-up__video" muted autoPlay loop controls={false} src={this.videoSrc} playsInline />
        <div className="coming-up coming-up--play-now">
          <label>In the meantime...</label>
          <div className="coming-up__play-now__text">
            Listen to our staff picks.
          </div>
          <div className="coming-up__play-now__button" onClick={StudioManager.instance.playRamdomStaffPick}>
            <i>&#9654;</i> play
          </div>
        </div>

        <div className="coming-up">
          <div className="coming-up__left">
            <label>Coming up</label>
            <div className="coming-up__title">
              next livestream at <span>{ this.state.time }</span>
            </div>
          </div>
          <div className="coming-up__right">
            <label>Program</label>
            <div className="coming-up__program">
              <div>
                { this.state.left.map((event, index) => (
                  <div key={`header-${index}}`} className="column__slot">
                    <div className="column__slot__time">{ `${event.hour}:00 - ${event.hour + 1}:00` }</div>
                    <div className="column__slot__artist">{ event.summary }</div>
                  </div>
                )) }
              </div>
              <div>
                { this.state.right.map((event, index) => (
                  <div key={`header-${index}}`} className="column__slot">
                    <div className="column__slot__time">{ `${event.hour}:00 - ${event.hour + 1}:00` }</div>
                    <div className="column__slot__artist">{ event.summary }</div>
                  </div>
                )) }
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : <div/>
  }
}
